import { Avatar, Box } from '@mui/material'
import styles from './index.module.scss'

export default function AgentProfileAvatarView({ size, avatarSrc, avatarAlt, ariaHidden, rootClass, waveStyle }) {
  if (avatarSrc) {
    return (
      <Avatar
        variant="circular"
        src={avatarSrc}
        alt={avatarAlt || undefined}
        aria-hidden={ariaHidden}
        className={rootClass}
        sx={{ width: size, height: size, flexShrink: 0, borderRadius: '50%', cornerShape: 'round' }}
      />
    )
  }

  return (
    <Box
      component="span"
      aria-hidden={ariaHidden}
      className={rootClass}
      sx={{
        ...waveStyle,
        display: 'inline-block',
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        cornerShape: 'round',
      }}
    >
      <span className={styles.waveBase} aria-hidden />
      <span className={styles.waveSpin} aria-hidden />
    </Box>
  )
}
